import React from "react";
import './Welcome.scss'
import mlynek from '../../../images/mlynek.svg';
import logo from '../../../images/logo.svg';
import { Img } from "@randajan/jet-react/dom/img";

const Welcome = () => {
    return (
        <section className="Welcome slab">
            <div className='ellipse'></div>
            <Img className='coffeMill' src={mlynek} />
            <article className='contentWrap'>
                <Img className='logo' src={logo} />
                <p className='welcomeText'>
                    <span>Máte rádi silnou dobrou kávu a k ní něco </span>
                    <span>lahodného k zakousnutí? To jste tu správně!</span>
                </p>
            </article>
        </section>
    );
};

export default Welcome;
